import React from "react";

interface Props {
	className?: string;
	width?: number;
	height?: number;
	color?: string;
}

export const IconKingLogo: React.FC<Props> = ({
	className = "",
	width = 215,
	height = 34,
	color = "#EF3E3E",
}) => {
	return (
		<svg
			width={width}
			height={height}
			viewBox="0 0 215 34"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			className={className}
		>
			<g id="icon-king-logo">
				<path
					d="M15.9878 25.7143H12.1507V24.1071L17.8104 21.4393L22.7026 25.7143H18.226V27.9643H31.0162V25.7143H27.0833L20.6882 20.1214L26.5397 17.3571H31.0162V15.1071H18.226V17.3571H21.9992L12.1507 21.9857V17.3571H15.9878V15.1071H5.43584V17.3571H9.2729V25.7143H5.43584V27.9643H15.9878V25.7143ZM36.4521 0V33.4286H0V0H6.10732L9.43278 4.17857H11.9588L15.2843 0H21.1678L24.4932 4.17857H27.0193L30.3448 0H36.4521ZM33.894 12.2143H2.55804V30.8571H33.894V12.2143ZM33.894 9.64286V2.57143H31.5598L28.2344 6.75H23.2782L19.9527 2.57143H16.4994L13.1739 6.75H8.18573L4.86028 2.57143H2.52607V9.64286H33.894Z"
					fill={color}
				/>
				<path
					d="M104.976 18.8036H108.909V19.7357C108.909 21.8571 108.781 22.725 108.621 23.0143L108.557 23.0786C108.365 23.2714 108.109 23.3036 107.342 23.3036H102.29C101.618 23.3036 101.394 23.2393 101.235 23.1107L101.203 23.0786C100.979 22.8536 100.851 22.275 100.851 18.9321V15.3964C100.851 11.6036 100.947 10.7036 101.171 10.4143L101.235 10.35C101.426 10.1571 101.618 10.125 102.45 10.125H107.278C107.949 10.125 108.205 10.1893 108.365 10.2857L108.429 10.35C108.589 10.5107 108.685 10.8964 108.749 12.2143V12.4393L108.781 13.275H111.691C111.627 10.125 111.435 9.06429 110.667 8.22858L110.571 8.13215C110.092 7.65 109.228 7.45715 107.694 7.45715H101.81C100.211 7.45715 99.6038 7.65 99.0282 8.19643C98.1649 9.06429 97.7812 10.2857 97.7492 15.5571V17.2607C97.7812 23.0143 98.1329 24.3 99.0282 25.2L99.0922 25.2321C99.6038 25.7143 100.179 25.9071 101.554 25.9071H108.013C109.42 25.9071 110.188 25.6821 110.795 25.1036C111.595 24.3 111.882 23.2393 111.882 19.4786V16.3286H105.04V18.8036H104.976Z"
					fill={color}
				/>
				<path
					d="M88.1885 9.99643H90.6826V21.9536H90.2989L84.3834 8.35715L84.2875 8.16429C84.0317 7.61786 83.8398 7.48929 83.1364 7.48929H76.9971V9.99643H79.4911V23.4643H76.9971V25.9714H84.6392V23.4643H82.1451V10.8643H82.5288L88.7001 25.0714L88.796 25.2643C89.0518 25.8107 89.2437 25.9393 89.9472 25.9393H93.3366V9.99643H95.7667V7.48929H88.1885V9.99643Z"
					fill={color}
				/>
				<path
					d="M66.7969 9.99643H69.323V23.4643H66.7969V25.9714H74.6309V23.4643H72.0729V9.99643H74.6309V7.45715H66.7969V9.99643Z"
					fill={color}
				/>
				<path
					d="M56.7885 16.1357L62.1284 9.99643H64.1749V7.45714H56.9164V9.93214H59.1227L54.7421 15.2036H52.0881V9.99643H54.5502V7.45714H46.8122V9.99643H49.2743V23.4643H46.8122V25.9714H54.5502V23.4643H52.0881V17.5821H54.6142L58.9948 23.5286H56.7885V25.9714H64.4307V23.4643H62.2883L56.7885 16.1357Z"
					fill={color}
				/>
				<path
					d="M192.045 18.0964H197.609V19.3822C197.545 23.0786 197.193 23.7536 196.713 24.2357L196.617 24.3322C196.298 24.6214 195.882 24.75 194.763 24.75H189.103C188.016 24.75 187.632 24.5893 187.313 24.3L187.217 24.2036C186.737 23.6893 186.353 22.6607 186.321 17.5179V16.1036C186.353 11.0571 186.673 9.83572 187.153 9.28929L187.281 9.16072C187.6 8.83929 188.016 8.67858 189.231 8.67858H194.891C196.042 8.67858 196.394 8.87143 196.745 9.19286C197.257 9.70715 197.481 10.6393 197.577 12.5679V12.9214H198.92V12.3429C198.824 10.125 198.536 9.03215 197.673 8.19643L197.609 8.13215C197.097 7.65 196.458 7.45715 195.019 7.45715H189.007C187.568 7.45715 186.897 7.68215 186.417 8.13215L186.193 8.35715C185.426 9.19286 185.042 10.6071 184.978 15.6214V17.3893C185.01 23.1107 185.458 24.3643 186.353 25.2322L186.417 25.2964C186.929 25.7786 187.6 25.9714 189.167 25.9714H195.051C196.522 25.9714 197.161 25.7464 197.641 25.2964L197.705 25.2322L197.833 25.0714C198.632 24.2357 199.016 23.1107 199.016 18.0964V16.9071H192.077V18.0964H192.045Z"
					fill={color}
				/>
				<path
					d="M213.501 7.45715L208.065 17.1643H207.905L202.437 7.45715H200.934L207.265 18.675V25.9714H208.64V18.6429L214.972 7.45715H213.501Z"
					fill={color}
				/>
				<path
					d="M120.036 25.9714H132.027V24.7822H121.443V16.9393H130.876V15.75H121.443V8.64643H132.155V7.45715H120.036V25.9714Z"
					fill={color}
				/>
				<path
					d="M147.759 24.1393H147.503L138.038 8.1L138.006 8.03572C137.751 7.58572 137.559 7.48929 137.015 7.48929H135.544V25.9714H136.855V9.09643H137.143L146.672 25.3286L146.704 25.3929C146.928 25.8107 147.151 25.9393 147.695 25.9393H149.102V7.45715H147.759V24.1393Z"
					fill={color}
				/>
				<path
					d="M181.205 21.2464V20.925L181.173 20.6036C181.013 18.0964 180.438 17.5179 178.967 17.1L178.775 17.0679V17.0357L179.095 16.9071C180.502 16.425 181.301 15.3964 181.301 12.4714C181.301 9.99643 180.917 9.09643 180.278 8.38929L180.054 8.16429C179.511 7.65 178.711 7.45715 177.528 7.45715H168.447V25.9714H169.822V17.6143H177.016C178.104 17.6143 178.679 17.8071 179.063 18.1929L179.159 18.2893C179.479 18.675 179.702 19.2536 179.766 20.9572V21.2786C179.83 22.9822 179.926 24.7179 180.118 25.9714H181.493L181.461 25.8107C181.397 24.6536 181.301 23.0143 181.205 21.2464ZM169.854 16.2643V8.64643H177.336C178.264 8.64643 178.807 8.80715 179.159 9.16072L179.287 9.28929C179.67 9.70715 180.022 10.2857 180.022 12.375C180.022 14.3679 179.638 15.1071 179.287 15.525L179.095 15.7179C178.711 16.0714 178.2 16.2643 177.144 16.2643H169.854Z"
					fill={color}
				/>
				<path
					d="M152.971 25.9714H164.962V24.7822H154.378V16.9393H163.811V15.75H154.378V8.64643H165.09V7.45715H152.971V25.9714Z"
					fill={color}
				/>
			</g>
		</svg>
	);
};
